"use client";

import type { ReactNode } from "react";
import { useDeferredMount } from "@/hooks/useDeferredMount";

interface DeferredMountProps {
  children: ReactNode;
  fallback?: ReactNode;
  timeoutMs?: number;
}

export default function DeferredMount({
  children,
  fallback = null,
  timeoutMs,
}: DeferredMountProps): ReactNode {
  const mounted = useDeferredMount(timeoutMs);
  return mounted ? children : fallback;
}
